<template>
  <div class="w-100 py-3">
    <b-skeleton
      animation="wave"
      width="100%"
      :height="size"
      :class="spacing_bottom"
      v-for="(n, index) in number"
      :key="index"
    ></b-skeleton>
  </div>
</template>
<script>
export default {
  props: {
    number: {
      type: Number,
      default: 1,
    },
    size: {
      type: String,
      default: "20px",
    },
    spacing_bottom: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
.b-skeleton:last-child {
  margin-bottom: 0px !important;
}
</style>